export const ActivateCoreFlags = {
  Auth0PrimaryEmailSync: 'squad-activate-core.auth0-primary-email-sync',
  Auth0VerificationFlowTracing:
    'squad-activate-core.auth0-verification-flow-tracing',
  MaintenanceMode: 'maintenance-mode',
  StagingPermittedDomains: 'activate.stagingPermittedDomains',
  UseRedirectServiceV1: 'api-platform-squad.use-redirect-service-v1',
  SAMLGraphql: 'squad-api-platform.saml-graphql',
  EnableAuth0SamlAsIdpIntegration:
    'squad-activate-core.enable-auth0-saml-as-idp-integration',
  Auth0AccessToken: 'squad-api-platform.auth0-access-token',
  Auth0ConsolidateAuthTokenStorage:
    'squad-api-platform.consolidate-auth-token-storage',
  Auth0RefreshToken: 'squad-api-platform.auth0-refresh-token',
  FixAuth0UserSessions: 'squad-api-platform.fix-auth0-user-sessions',
  ReservableCapacityValidation:
    'activate-experience-integrations.reservable-capacity-validation',
  DisableWhitelabelOAuthConfig:
    'squad-api-platform.disable-whitelabel-oauthconfig',
  PrismaMigrationRemoveUserIntegrationResolver:
    'pavel.prisma-migration-remove-user-integration-resolver',
  ChannelManagementGoLive: 'foundations.channel-management-go-live',
  MultifamilyCreateProperty: 'multifamily.create-property',
  IntuitiveUserManagement: 'multifamily.intuitive-user-management',
  AddManualResidents: 'multifamily.add-manual-residents',
  MessagingAndMarketplace: 'multifamily.messaging-and-marketplace',
  MediaUploadV2: 'multifamily.media-upload-v2',
  HeicMediaUpload: 'squad-activate-core.heic-media-upload',
  HeicAttachmentUpload: 'squad-activate-core.heic-attachment-upload',
  UrgentCommunicationMessage: 'multifamily.urgent-communications-message',
  RelayUI: 'squad-relay-and-beacon.relay-UI',
  PushNotificationPermissionModal:
    'squad-activate-core.show-push-notification-permission-modal',
  PrismaMigrationVerifyEmailOnBehalfOfUserResolver:
    'pavel.prisma-migration-verify-email-on-behalf-of-user-resolver',
  PrismaMigrationRequestAccountDeletionResolver:
    'pavel.prisma-migration-request-account-deletion-resolver',
  CoreTouchContentLightweightResponse:
    'squad-core.touch-content.lightweight-response',
  NotificationsPerformanceUsersMultiQuery:
    'activate-core.notifications-performance.users-multi-query',
  EnableOAuthAuth0UserDetection:
    'squad-activate-core.enable-oauth-auth0-user-detection',
  UseOIDCConnectionParameter:
    'squad-activate-core.use-oidc-connection-parameter',
  MobileClearSessionWhenExpiredRedirect:
    'squad-activate-core.mobile-clear-session-when-expired-redirect',
  PhoneInputCountryCodeChangeFix:
    'squad-activate-core.phone-input-country-code-change-fix',
  SectionContentListBgFix: 'squad-activate-core.section-content-list-bg-fix',
  ContentItemsAlignmentFixMobile:
    'squad-activate-core.content-items-alignment-fix-mobile',
  FixDraftContentPlacementRevalidation:
    'squad-activate-core.fix-draft-content-placement-revalidation-fix',
  WhitelabelOutlineButtonBackgroundFix:
    'squad-activate-core.whitelabel-outline-button-background-fix',
  MixpanelEnabled: 'squad-activate-core.mixpanel-enabled',
  ContentNotificationReducedBatchSize:
    'squad-activate-core.content-notification-reduced-batch-size',
  OldUnscheduledNotificationGuard:
    'squad-activate-core.old-unscheduled-notification-guard',
  GraphqlUserPiiGuard: 'squad-activate-core.graphql-user-pii-guard',
  GetUsersByChannelIdTransactionFix:
    'activate-core.user-management.get-users-by-channel-id-transaction-fix',
  GetUsersByChannelIdOptimisation:
    'squad-activate-core.user-management.get-users-by-channel-id-optimisation',
  UpdateUserLastSeenThrottle:
    'squad-activate-core.user-management.update-user-last-seen-throttle',
  FixReactivationCheckForUserManagement:
    'squad-activate-core.fix-reactivation-check-for-user-management',
  FixDuplicateInactiveEmail:
    'squad-activate-core.user-management.fix-duplicate-inactive-email',
  ReturnFirstChannelIfDefaultChannelIsNull:
    'squad-activate-core.return-first-channel-if-default-channel-is-null',
  GroupRoleAudienceChannelFieldResolver:
    'squad-activate-core.group-role.audience-channel-field-resolver',
  DropdownItemSelectionFix: 'squad-activate-core.dropdown-item-selection-fix',
  PlatformOfflineFramework: 'squad-activate-core.offline-usage-framework',
  Auth0ForcePromptLogin:
    'squad-activate-core.authentication.auth0_force_prompt_login',
  UserLoggingRedirectAuth0Fix:
    'squad-activate-core.user-logging-redirect-auth0-fix',
  PushNotificationUseChannelDisplayName:
    'squad-activate-core.push-notification-use-channel-display-name',
  WorkflowStatusChangeConditionalRulesFix:
    'squad-activate-core.workflow-status-change-conditional-rules-fix',
  BackButtonNotVisibleFilterContent:
    'squad-activate-core.back-button-not-visible-filter-content',
  Auth0TranslationFix: 'squad-activate-core.auth0-translation-fix',
  MapsModuleFixes: 'squad-activate-core.maps-module-fixes',
  PostResetTimeNotTriggeringFix:
    'squad-activate-core.post-reset-time-not-triggering-fix',
  FixExpireContentLoad: 'squad-activate-core.fix-expire-content-load',
  ReservableTeamRulesFix: 'squad-activate-core.reservable-team-rules-fix',
  FixUnableToRemoveChannelLogo:
    'squad-activate-core.fix-unable-to-remove-channel-logo',
  ContentLogoRemovalFix: 'squad-activate-core.content-logo-removal-fix',
  QuotaRedemptionExceedsFix: 'squad-activate-core.quota-redemption-exceeds-fix',
  OnboardingCompanyAutoJoinFix:
    'squad-activate-core.onboarding-company-auto-join-fix',
  EnablePhoneVerificationUserIdRateLimits:
    'squad-activate-core.enable-phone-verification-user-id-rate-limits',
  MixedLanguageContentNotificationEmailFix:
    'squad-activate-core.mixed-language-content-notification-email-fix',
  EnableVisitorManagementV2Emails:
    'squad-activate-core.enable-visitor-management-v2-emails',
  EnableReservationMonthlyCalendarView:
    'squad-activate-core.enable-reservation-monthly-calendar-view',
  EmailViewButtonMultiTabFix:
    'squad-activate-core.email-view-button-multi-tab-fix',
  AttachmentFieldRenderUuidEmailFix:
    'squad-activate-core.attachment-field-render-uuid-email-fix',
  EnablePhoneVerificationClientIpRateLimit:
    'squad-activate-core.enable-phone-verification-client-ip-rate-limits',
  PhoneVerificationSmsPumpingRiskMode:
    'squad-activate-core.phone-verification-sms-pumping-risk-mode',
  PhoneVerificationSmsPumpingRiskThreshold:
    'squad-activate-core.phone-verification-sms-pumping-risk-threshold',
  ContentAccessAudienceTargetingFix:
    'squad-activate-core.content-access.audience-targeting-fix',
  AudienceTargetedContentAppearsOtherChannelFix:
    'squad-activate-core.audience-targeted-content-appears-other-channel-fix',
  ContentDataConditionalFieldFix:
    'squad-activate-core.content-data-conditional-field-fix',
  SplitReserveAndPaymentFix:
    'squad-activate-core.split_reserve_and_payment_fix',
  FilterReceiptEmailFieldsByLayout:
    'squad-activate-core.filter-receipt-email-fields-by-layout',
  NotificationSentRepublishingFix:
    'squad-activate-core.notification-sent-republishing-fix',

  // Rogue flags
  ActivatePlatformCoreActivateRebrand:
    'activate-platform-core.activate-rebrand',
  ActivatePlatformCoreHidePendoWidget:
    'activate-platform-core.hide-pendo-widget',
  ActivatePlatformCoreHideZendeskWidget:
    'activate-platform-core.hide-zendesk-widget',
  ActivatePlatformCoreKoaCompression: 'activate-platform-core.koa-compression',
  ActivatePlatformCoreShowWhitelabelNameInSms:
    'activate-platform-core.show-whitelabel-name-in-sms',
  ApiPlatformDisableStudioCustomOnboarding:
    'api-platform.disable-studio-custom-onboarding',
  OtherIntegrationsOneWaySyncCalendarIntegrationTest:
    'other-integrations.one-way-sync-calendar-integration-test',
  OtherIntegrationsRiseActivateViabilityPoc:
    'other-integrations.rise-activate-viability-poc',
  SquadApiPlatformActivateTokenManager:
    'squad-api-platform.activate-token-manager',
  SquadApiPlatformAuth0EnableOidcWebviewScene:
    'squad-api-platform.auth0-enable-oidc-webview-scene',
  SquadApiPlatformAuth0RedirectIos184:
    'squad-api-platform.auth0-redirect-ios-18-4',
  SquadApiPlatformAuthenticateMiddlewareLib:
    'squad-api-platform.authenticate-middleware-lib',
  SquadApiPlatformOidcV2: 'squad-api-platform.oidc-v2',
  SquadApiPlatformRequirePresenceOfAcmSession:
    'squad-api-platform.require-presence-of-acm-session',
  UsersServiceUseNewUserService: 'users-service.use-new-user-service',
  CoreApiPlatformActivateSessionExpire:
    'core-api-platform.activate-session-expire',
  CoreApiClearSessionCallback: 'core-api.clear-session-callback',
  MultifamilyParcelManagement: 'multifamily.parcel-management',
  MultifamilyResidentDetails: 'multifamily.resident-details',
  MultifamilyUnitFloors: 'multifamily.unit-floors',
  FastContentQuery:
    'activate-core-experience-content-query-optimization-resolver',
  ChannelForAdminQuery: 'activate-core.channel-for-admin-query',
  // Rogue flags end
  FixOptionalNumberFieldValidation:
    'squad-activate-core.fix-optional-number-field-validation',
  FixInviteDeletionUponTeamRemoval:
    'squad-activate-core.fix-invite-deletion-upon-team-removal',
  FixCaseSensitivityInEmailChannelInvite:
    'squad-activate-core.fix-case-sensitivity-in-email-channel-invite',
  FixTemplateDeleteButton: 'squad-activate-core.fix-template-delete-button',
  FixLegacyPromptOnRestrictedAccessPage:
    'squad-activate-core.fix-legacy-prompt-on-restricted-access-page',
  FixRichTextEditorInSafari:
    'squad-activate-core.fix-rich-text-editor-in-safari',
  ChineseCharactersDuplicationFix:
    'squad-activate-core.chinese-characters-duplication-fix',
  PdfFileFailedToLoadFix: 'squad-activate-core.pdf-file-failed-to-load-fix',
  FixDateTimeRangeValidation:
    'squad-activate-core.fix-date-time-range-validation',
  ContentNotificationImageEnabled:
    'squad-activate-core.enable-image-for-content-notification-v2-email',
  FixTabVisibilityForTenantTargetedPages:
    'squad-activate-core.fix-tab-visibility-for-tenant-targeted-pages',
  FixVulnerableAttachmentsForContentInteraction:
    'squad-activate-core.fix-vulnerable-attachments-for-content-interaction',
  ContentWorkflowDuplicateRecipientGuard:
    'squad-activate-core.content-workflow-duplicate-recipient-guard',
  FixInviteExpiredErrorAfterSignup:
    'squad-activate-core.fix-invite-expired-error-after-signup',
  EnableResourceCalendar: 'squad-activate-core.enable-resource-calendar',
  FixPortalReadyStateRace: 'squad-activate-core.fix-portal-ready-state-race',
  OptimizeChannelQueries: 'squad-activate-core.optimize-channel-queries',
  RestrictWebsiteUrlSchemes:
    'squad-activate-core.website-url.restrict-url-schemes',
  SortMemberActivityByMostRecent:
    'squad-activate-core.sort-member-activity-by-most-recent',
} as const;
